'use client'

import type { ComponentPropsWithoutRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from 'ui/src/components/Text/Text'
import { yStack } from 'ui/src/patterns/stack'
import { AttentionCard } from '../InfoCard/InfoCard'

type Props = {
  errors?: Array<string>
} & ComponentPropsWithoutRef<'div'>

export function ErrorMessages({ errors, ...props }: Props) {
  const { t } = useTranslation()

  if (!errors) {
    return null
  }

  return (
    <div {...props}>
      <AttentionCard>
        <div className={yStack({ gap: 'xs' })} style={{ width: '100%' }}>
          <Text as="p" size={{ _: 'md', lg: 'lg' }} color="signalAmberText">
            {t('GENERAL_ERROR_DIALOG_TITLE')}
          </Text>
          <div className={yStack({ gap: 'xs' })}>
            {errors.map((error) => (
              <Text size={{ _: 'md', lg: 'lg' }} color="signalAmberText" balance={true} key={error}>
                {error}
              </Text>
            ))}
          </div>
        </div>
      </AttentionCard>
    </div>
  )
}
